/**
 * Показ уведомления о технических работах
 * @param title {string} - текст сообщения
 *
 * @returns void
 */
let showNotification = function (title) {
    $(kbSelector.technicalMessage).text(title);
    $(kbSelector.technicalNotification).show();
};

/**
 * Запрос на отображение уведомления о технических работах
 *
 * @returns void
 */
let checkTechnicalNotification = function () {
    let endPoint = actions.technicalNotification.show;

    if(!isUserLogin) return;

    axios.post(endPoint).then(response => {
        if(response.data.result) {
            showNotification(response.data.message);
        }
    });
}

/**
 * Обаботчик закрытия уведомления о технических работах
 *
 * @returns void
 */
let closeTechnicalNotification = function () {
    let endPoint = actions.technicalNotification.close;

    axios.post(endPoint);

    $(kbSelector.technicalNotification).hide();
};

;(function () {
    $(kbSelector.technicalNotificationCloseBtn).on('click', closeTechnicalNotification);

    checkTechnicalNotification();
}());